import { TESTIMONIALS } from '../../mock';
import { Quote } from 'lucide-react';

export default function Testimonials() {
  return (
    <section className="py-20 lg:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#0B3B2E]/70 font-medium reveal">
          What clients say
        </p>
        <h2 className="mt-4 font-serif text-[36px] lg:text-[48px] leading-[1.05] text-[#0B3B2E] max-w-[720px] reveal">
          Not a testimonial page. <span className="italic">A track record.</span>
        </h2>

        <div className="mt-14 grid md:grid-cols-3 gap-4">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              className="reveal relative p-7 rounded-2xl bg-[#F5F1E8] border border-[#0B3B2E]/12 hover:border-[#0B3B2E]/30 transition-colors duration-300"
            >
              <Quote className="w-8 h-8 text-[#C8944B]" strokeWidth={1.6} />
              <blockquote className="mt-4 font-serif text-[20px] leading-snug text-[#0B3B2E]">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[#0B3B2E]/10">
                <p className="font-medium text-[14px] text-[#0B3B2E]">{t.name}</p>
                <p className="text-[13px] text-[#0E1F1A]/60">{t.role}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
